var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0D84D2EC-0DB4-4936-9023-641169B06E52@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workout-Builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Templates",
    transform: "translate(-20.000000, -373.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(20.000000, 370.455265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0008203,13.062314 C12.9497266,13.062314 15.8986328,13.062314 18.8475781,13.062314 C19.1725391,13.062314 19.1728711,13.0619632 19.1728711,12.7179612 C19.1728711,8.90506388 19.1728711,5.09220907 19.1728711,1.27931173 C19.1728711,0.937818882 19.1725391,0.937287293 18.8655078,0.937287293 C12.9546484,0.937287293 7.04378906,0.937287293 1.13292969,0.937287293 C0.827734375,0.937287293 0.827172114,0.937818882 0.827172114,1.25979178 C0.827172114,5.08685065 0.827172114,8.91390952 0.827172114,12.7409684 C0.827172114,13.0617505 0.827773437,13.062314 1.13453125,13.062314 C4.08996094,13.062314 7.04539062,13.062314 10.0008203,13.062314 M0,0.00345532924 C0.0650390625,0.00230709675 0.130039063,0 0.195078125,0 C6.73167969,0 13.2683203,0 19.8049609,0 C19.8699609,0 19.935,0.00230709675 20,0.00345532924 L20,13.9948808 C19.9219922,13.9966244 19.8439844,13.9998565 19.7659766,13.9998565 C13.2553516,14.0000478 6.7446875,14.0000478 0.234023438,13.9998565 C0.156015625,13.9998565 0.0780078125,13.9966244 0,13.9948808 C0,9.33105813 0,4.66727799 0,0.00345532924",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00019538,6.98353598 C8.00019538,6.17758034 8,5.3716247 8.00054951,4.56571077 C8.00058886,4.48244969 7.99889692,4.39818746 8.00967808,4.31613608 C8.04756951,4.02722512 8.23458711,3.92056249 8.47472355,4.06226485 C8.89263098,4.30879442 9.30495109,4.56596106 9.71927792,4.81933172 C10.7181086,5.43027454 11.7167818,6.04163451 12.715455,6.65286933 C12.7438244,6.67022235 12.7726266,6.68699136 12.7999336,6.70605465 C13.0690297,6.89410123 13.0679279,7.12765776 12.7889951,7.30143816 C12.2353396,7.64624585 11.6784182,7.98508844 11.1222838,8.32539102 C10.2767895,8.84281112 9.43090173,9.3595638 8.58481723,9.87589934 C8.52253049,9.91390076 8.45988962,9.95482217 8.39252708,9.97922484 C8.22002862,10.0416707 8.07224025,9.96053698 8.02931237,9.77357496 C8.00637291,9.67375343 8.00165123,9.5673828 8.0013758,9.46389044 C7.9992904,8.63711953 8.00019538,7.8103069 8.00019538,6.98353598",
    id: "Fill-6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLibrary);
export default __webpack_public_path__ + "static/media/video_library.19fa7eef894819eb7c2e267979019b8e.svg";
export { ForwardRef as ReactComponent };